<template lang="pug"></template>

<script>
export default {
    name: 'BotaoAnaliseDesmatamento',
    componentOptions: {
        title: 'Pessoa',
        actions: [
            [
                {
                    name: 'Analise Desmatamento',
                    iconClass: 'lyra-icon lyra-desmatamento',
                    showView: false,
                    action: 'abrirAnaliseDesmatamento',
                    route: 'analise-desmatamento',
                    nameTranslationKey:
                        'mensagens.menuLateral.analiseDesmatamento'
                }
            ]
        ]
    },

    methods: {
        abrirAnaliseDesmatamento() {
            this.$router.push({ name: 'Analise Desmatamento' });
        }
    }
};
</script>
